module.exports = __webpack_public_path__ + "static/media/CitizenIconFilled.53ead1e9.png";